import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import CircleDm from "../../UI/CircleDm/CircleDm";
import DmSignal from "../../UI/DmSignal/DmSignal";
import DmLink from "../../UI/DmLink/DmLink";
import DmStatus from "../../UI/DmStatus/DmStatus";
import DmGun from '../../UI/DmGun/DmGun';
import DmRezIn from '../../UI/DmRezIn/DmRezIn';
import PressureSensor from "../../UI/PressureSensor/PressureSensor";
import AnglePosition from "../../UI/AnglePosition/AnglePosition";
import { checkDeviceLink } from '../../Utils/DateFormatter';
import './DmInfo.css';

const DmInfo = React.memo(() => {
    const parameter = useSelector((state) => state.dmimei?.data[0]);

     const signalValue = parameter?.Sig_Value ?? '...';
     const param_last_date = parameter?.param_last_date ?? 0;
     const status = parameter?.param4 ?? '...';
     const angleCurrent = parameter?.AngleCurrent ?? '...';
     const adc = parameter?.param3 ?? 0;
     const pmax = parameter?.PMax ?? 0;

    const browserTime = new Date();
    const islink = useMemo(() => {
        return checkDeviceLink(param_last_date, browserTime) ? 'Online' : 'Offline';
    }, [param_last_date]);

    return(

        <div className="dmCardInfo">
            <div className="cardInfoHeader">
                <DmSignal signalValue={signalValue} param_last_date={param_last_date}
                browserTime={browserTime} />
                <DmLink islink={islink} />
            </div>
            <div className="cardInfoBody">
                <div className="cardInfoBodyCircle">
                    {/* <CircleDm data={parameter} islink={islink} /> */}
                    <CircleDm islink={islink}
                        angleCurrent={parameter?.AngleCurrent}
                        param4={parameter?.param4}
                        offsetNulN={parameter?.OffsetNulN}
                        flagBarrier={parameter?.FlagBarrier}
                        angleForward={parameter?.AngleForward}
                        angleRevers={parameter?.AngleRevers}
                        />
                </div>
                <div className="InfoBodyBlock">
                    <DmStatus status={status} islink={islink} />
                    <div className="InfoParam"> 
                    <AnglePosition angleCurrent={angleCurrent} />
                    <PressureSensor adc={adc} pmax={pmax} islink={islink} />
                    <DmGun islink={islink} status={status} />
                    <DmRezIn islink={islink} status={status} />
                    </div>
                </div>
            </div>
        </div>
    )
});
// DmInfo.displayName = 'DmInfo';
export default DmInfo;